import axios from 'axios';
import { FETCH_LIST } from './types';
import api from '../../../utils/api';

export default {
  async fetchList({ commit }) {
    const response = await axios(api.tags.fetch());
    commit(FETCH_LIST, { items: response.data.results });
  },
  async tagRecommendation(_, addTags) {
    await axios(api.tags.create(addTags));
  },
  async createTag(_, tags) {
    const { data } = await axios(api.tags.newTag(tags));
    return data;
  },
  async createTags(_, tags) {
    const { data } = await axios(api.tags.createTags(tags));
    return data;
  },
};
